import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../../services/auth.js";
import events from "../../../services/events.js";
import security from "../../../services/security.js";
import common from "../../../services/common.js";
import scroll from "../../../services/scroll.js";
import env from "../../../services/env.js";
import messaging from "../../../services/messagingv2.js";

class RejectedapplicantsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    $stateParams,
    SecurityService,
    CommonService,
    ScrollService,
    $rootScope,
    $scope,
    EnvService,
    $timeout,
    Messagingv2Service,
    TrackingService,
    $anchorScroll,
    $location
  ) {
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    $localStorage.activeStateName = "events";
    this.name = "rejectedapplicants";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$common = CommonService;
    this.$scroll = ScrollService;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$messagingv2 = Messagingv2Service;
    this.$anchor = $anchorScroll;
    //this.rejects = [];
    //this.quitters = [];
    //this.withdraws = [];
    this.page = 1;
    this.$env = EnvService;
    this.$location = $location;
    this.$timeout = $timeout;
    var _this = this;

    _this.LoadRejectedApplicantsListener = _this.$rootScope.$on("LoadRejectedApplicants", function ($event, params) {
      _this.setRejectedApplicants(params, 100, 0);
    });

    _this.setRejectedApplicantToDirectiveListener = _this.$rootScope.$on("setRejectedApplicantToDirective", function ($event, params) {
      _this.mapRejectedApplicant(params);
    });

    _this.$scope.$on("$destroy", _this.LoadRejectedApplicantsListener);
    _this.$scope.$on("$destroy", _this.setRejectedApplicantToDirectiveListener);
  }

  mapRejectedApplicant(a) {
    var _this = this;

    let reject = {};
    console.log("we are def missing some data");
    console.dir(a);
    reject.applicantFirstName = a.applicant.firstName;
    reject.applicantLastName = a.applicant.lastName;
    reject.applicantEmail = a.applicant.username;
    reject.applicantPhoneNumber = a.applicant.homeContactInfo.phoneMobile;
    reject.filePROFILE_IMAGE1IMG_75x75 = a.applicant.filePROFILE_IMAGE1IMG_75x75
      ? a.applicant.filePROFILE_IMAGE1IMG_75x75
      : "/app/vendor/images/brax.png";
    reject.applicantHomeContactInfo = {};
    reject.applicantHomeContactInfo.city = a.applicant.homeContactInfo.city;
    reject.applicantHomeContactInfo.state = a.applicant.homeContactInfo.state;
    reject.averageRatingReceived = a.applicant.displayRating;
    reject.numberOfCompletedJobbles = a.applicant.numberOfCompletedJobbles;
    reject.isApplicantVerified = a.applicant.isVerified;
    reject.id = a.id;
    reject.applicantId = a.applicant.id;

    _this.rejects.unshift(reject);
    _this.figure_out_which_table();
  }

  setRejectedApplicants(params, max, offset) {
    var _this = this;
    let jpid = params.subEvents[0].deduppedJobbles[0].jobblePoolId;
    _this.$events.getRejectingApplicationsTrimmedReview(jpid, max).then(
      function (response) {
        console.log("response");
        console.dir(response);
        var rejects = response.data;
        console.log("rejects response");
        console.dir(rejects);
        try {
          rejects.forEach(function (r) {
            console.log("iteration?");
            _this.fixApplicantPhone(r);
            _this.findDeletedApplicants(r);
          });
        } catch (err) {
          console.log("error with rejects");
          console.dir(err);
        } finally {
          console.log("in the finally..");
          console.dir(rejects);
          _this.getQuitApplicants(jpid);
          _this.getWithdrawnApplicants(jpid);
          _this.rejects = rejects;
        }
      },
      function (error) {
        //alert()
      }
    );
  }

  fixApplicantPhone(applicant) {
    var _this = this;
    let num = applicant.applicantPhoneNumber;
    if (num) {
      if (num.charAt(0) === "1") {
        num = num.slice(1, num.length);
      }
      let cleaned = ("" + num).replace(/\D/g, "");
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        applicant.applicantPhoneNumber = "(" + match[1] + ") " + match[2] + "-" + match[3];
      } else {
        applicant.applicantPhoneNumber = num;
      }
    }
  }

  reverse(app) {
    var _this = this;
    let aid = app.id;
    console.log("reverse");
    console.dir(app);
    _this.setLoader();
    _this.$events.reverseReject(aid).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.splice_application(app, response.data.jobble.id);
        _this.unSetLoader();
      },
      function (error) {
        alert("Error : " + error);
        _this.unSetLoader();
      }
    );
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  splice_application(app, jid) {
    var _this = this;
    let app_to_splice = null;
    let index_to_splice = null;
    if (_this.page === 1) {
      app_to_splice = _this.rejects.find((o) => o.id === app.id);
      index_to_splice = _this.rejects.findIndex((x) => x.id === app.id);
      _this.rejects.splice(index_to_splice, 1);
      _this.check_for_more(1);
    } else if (_this.page === 3) {
      app_to_splice = _this.withdraws.find((o) => o.id === app.id);
      index_to_splice = _this.withdraws.findIndex((x) => x.id === app.id);
      _this.withdraws.splice(index_to_splice, 1);
      _this.check_for_more(3);
    } else {
      app_to_splice = _this.quitters.find((o) => o.id === app.id);
      index_to_splice = _this.quitters.findIndex((x) => x.id === app.id);
      _this.quitters.splice(index_to_splice, 1);
      _this.check_for_more(2);
    }
    _this.set_application_to_pending(app_to_splice, jid);
  }

  check_for_more(p) {
    var _this = this;
    switch (p) {
      case 1:
        console.log("case 1");
        break;
      case 2:
        console.log("case 2");
        break;
      case 3:
        console.log("case 3");
        break;
    }
  }

  set_application_to_pending(app, jid) {
    var _this = this;
    if (!app.jobbleId) {
      app.jobbleId = jid;
    }
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetApplicationToPending", app);
    });
  }

  findDeletedApplicants(app) {
    var _this = this;
    if (app.applicantIsDeleted === true) {
      console.log("we found one");
    }
  }

  getWithdrawnApplicants(poolId) {
    var _this = this;
    _this.$events.getWithdrawnApplicationsTrimmedReview(poolId, 100).then(
      function (response) {
        let w = response.data;
        try {
          w.forEach(function (withd) {
            _this.fixApplicantPhone(withd);
            _this.findDeletedApplicants(withd);
          });
        } catch (err) {
        } finally {
          _this.withdraws = w;
          _this.$timeout(function () {
            _this.figure_out_which_table();
          }, 300);
        }
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  getQuitApplicants(poolId) {
    var _this = this;
    _this.$events.getQuitedApplicationsTrimmedReview(poolId, 100).then(
      function (response) {
        let q = response.data;
        try {
          q.forEach(function (quitter) {
            _this.fixApplicantPhone(quitter);
            _this.findDeletedApplicants(quitter);
          });
        } catch (err) {
        } finally {
          _this.quitters = q;
          console.log("_this.quitters");
          console.dir(_this.quitters);
        }
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  setPage(p) {
    var _this = this;

    _this.page = p;
  }

  figure_out_which_table() {
    var _this = this;

    if (_this.rejects.length > 0 || _this.quitters.length > 0 || _this.withdraws.length > 0) {
      _this.show_tables = true;
      if (_this.rejects.length > 0) {
        _this.page = 1;
        return;
      } else if (_this.quitters.length > 0) {
        _this.page = 2;
        return;
      } else {
        _this.page = 3;
      }
    }
  }
}

RejectedapplicantsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "$stateParams",
  "security",
  "common",
  "scroll",
  "$rootScope",
  "$scope",
  "env",
  "$timeout",
  "messagingv2",
  "tracking",
  "$anchorScroll",
  "$location",
];

export default RejectedapplicantsController;



// WEBPACK FOOTER //
// ./client/app/components/eventreviewapplicants/rejectedapplicants/rejectedapplicants.controller.js